import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import {useTranslation} from "react-i18next";
import Icon from "../../componentsReusable/Icon";

export default function FileRemove(props){
  const { t } = useTranslation('files');
  const [deleting, setDeleting] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggleModalOpen = () => setModalOpen(!modalOpen);

  const deleteFile = () => {
    setDeleting(true);

    props.deleteFileFn(props.file.id)
    .then(data => {
      setDeleting(false);
      setModalOpen(false);
      props.onRemoved(props.file);
    })
    .catch(res => {
      setDeleting(false);
    })
  }

  return <React.Fragment>
    <Icon tooltip={t('remove.file_remove_icon_tooltip')} onClick={toggleModalOpen} className="remove-button fas fa-times-circle text-danger cursor-pointer p-1" />
    {modalOpen && <Modal className="modal-danger" isOpen={true}>
      <ModalHeader toggle={toggleModalOpen}>{t('remove.modal_header')}</ModalHeader>
      <hr className="my-0"/>
      <ModalBody>{t('remove.modal_body')}</ModalBody>
      <ModalFooter>
        <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>{t('common:btn.cancel')}</Button>
        <Button
          color="danger"
          loading={deleting}
          onClick={deleteFile}
        >{t('remove.modal_footer_btn_confirm')}</Button>
      </ModalFooter>
    </Modal>}
  </React.Fragment>
}

FileRemove.propTypes = {
  deleteFileFn: PropTypes.func.isRequired,
  file: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  onRemoved: PropTypes.func.isRequired,
};
